import { useParams } from "react-router-dom";
import ThingsToDo from "./ThingsTODOIndex";
import FilterPopularThings from "./FilterPopularThings";
import MusicThings from "./MusicThings";
import PopularEntertainment from "./PopularEntertainment";

const CATEGORIES = [
  "Shopping",
  "Day-Trip",
  "Museum",
  "Sightseeing",
  "Night-Life",
  "Top-Attractions",
  "Fine-dining",
];

const MUSIC_CATEGORIES = [
  "Rock",
  "Blues",
  "Jazz",
  "Country",
  "Concerts",
];

const POPULARENTERTAINMENT_CATEGORIES = [
  "Performing",
  "Brewery",
  "Comedy",
  "Family",
];

export default function ThingsToDoRouteDecider() {
  const { value } = useParams();

  if (!value) return <ThingsToDo />;

  const slug = value.toLowerCase();

  const isMusicCategory = MUSIC_CATEGORIES.some(
    c => c.toLowerCase() === slug
  );

  const isCategory = CATEGORIES.some(
    c => c.toLowerCase() === slug
  );

  const isPopularEntertainmentCategory = POPULARENTERTAINMENT_CATEGORIES.some(
    c => c.toLowerCase() === slug
  );

  if (isPopularEntertainmentCategory) {
    return <PopularEntertainment category={value} />;
  }

  if (isMusicCategory) {
    return <MusicThings category={value} />;
  }

  if (isCategory) {
    return <FilterPopularThings />;
  }

  return <ThingsToDo />;
}
